import React from 'react';
import { motion } from 'framer-motion';
import { FiClock, FiCheckCircle, FiXCircle } from 'react-icons/fi';

const statusMap = {
  pending: {
    icon: FiClock,
    color: '#FFA726',
    label: 'Pending',
    animate: { rotate: [0, 360] },
    transition: { repeat: Infinity, duration: 1.2, ease: 'linear' },
  },
  confirmed: {
    icon: FiCheckCircle,
    color: '#4CAF50',
    label: 'Confirmed',
    animate: { scale: [1, 1.15, 1] },
    transition: { repeat: Infinity, duration: 1.2, ease: 'easeInOut' },
  },
  failed: {
    icon: FiXCircle,
    color: '#FF4B55',
    label: 'Failed',
    animate: { scale: [1, 0.9, 1] },
    transition: { repeat: Infinity, duration: 1.2, ease: 'easeInOut' },
  },
};

const TransactionStatusIcon = ({ status, size = 20 }) => {
  const config = statusMap[status] || statusMap.confirmed;
  const Icon = config.icon;
  return (
    <motion.span
      title={config.label}
      aria-label={config.label}
      style={{ color: config.color, display: 'inline-flex', alignItems: 'center' }}
      animate={config.animate}
      transition={config.transition}
    >
      <Icon size={size} />
    </motion.span>
  );
};

export default TransactionStatusIcon; 